import moment from 'moment';
import { validateArray } from '../util/util.js';

function hasContractRemainingQuantity(contractBreakdown, minimumOrder = 0){
    if (!validateArray(contractBreakdown)) {
        return false
    }
    let currentContractPeriod = contractBreakdown.find(p => moment(p.until_date).isSameOrAfter(moment(), 'day')); // Find the current contract period/month
    if (currentContractPeriod) {
        return currentContractPeriod.maximumAvailable >= minimumOrder; // Does the contract have enough fuel left to be purchasable at minimum order size?
    }

    return false; // There is no valid period/month for this contract
}

function getCurrentMonthDataFromContract(frequencyQuantity){
    const now = new Date();
    
    for(let i = 0; i < frequencyQuantity.length; i++){
        let until = new Date(frequencyQuantity[i].until_date);
        if(now.getMonth() === until.getMonth() && now.getFullYear() === until.getFullYear()){
            return  frequencyQuantity[i];
        } 
    }
}


function makeGenericContractFromContractFrequency(offer){
  if ((!offer.isContract || !offer.contract.frequency_quantity || offer.contract.frequency_quantity.length === 0)) {
    return offer;
  }
  const month = getCurrentMonthDataFromContract(offer.contract.frequency_quantity);
  offer.maximumAvailable = month.maximumAvailable;
  offer.totalQuantityForMonth = month.quantity;
  return offer;
}

function populateContractDetails(offer, objectFormat){
    let contract = {};

    if (objectFormat === "OFFER"){ // If the object is still in an offer format, we need to populate its location
        if(offer.storage_type_id === "SPOT"){
            offer.location = offer.terminal ? offer.terminal.name : "N/A";
        } else {
            offer.location = offer.network_id === "UK" ? "UK Fuels" : "Keyfuels";
        }
    }
    
    contract.seller = offer.sellerName;
    contract.fuelName = offer.fuelName;
    contract.location = offer.location;
    contract.reference = offer.contract.reference;
    contract.totalVol = offer.contract.totalQuantity;
    contract.maximumAvailable = offer.maximumAvailable;
    contract.measurement = offer.fuel_measurement_id;
    contract.collectionDays = offer.collectionTime;
    contract.start = offer.contract.start;
    contract.end = offer.contract.end;
    contract.frequencyQty = offer.contract.frequency_quantity;
    contract.reference = offer.contract.reference;

    return contract;
}

function _isDateWithinContractAvailability(contractEndDate, contractStartDate){
  if(moment(contractEndDate).isBefore(moment().startOf('day')))
    return false; // Contract has expired
  else if(moment(contractStartDate).isAfter(moment().endOf('day')))
    return false; // Contract has not started yet
  
  return true; // Today is still within the contract's availability period
}

export { 
    hasContractRemainingQuantity,
    populateContractDetails,
    makeGenericContractFromContractFrequency,
    getCurrentMonthDataFromContract,
    _isDateWithinContractAvailability
};